import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { type RehabQueryChoiceList } from '@Types';
import { type TFunc } from '@Translations/types';
import {
	type AssetTypeId,
	type SystemTypeId,
} from '@innovyze/lib_asset_schema';

export const populateFieldOptions = createAction<{ fieldOptions: [] }>(
	addNamespace('choiceList/populateFieldOptions'),
);

export const getAllRehabRuleChoiceListFiles = createAction<{
	systemType?: SystemTypeId;
	assetType?: AssetTypeId;
	inspectionStandard?: string;
	treeId?: string;
	t: TFunc;
	shouldShowFullDefects: boolean;
}>(addNamespace('choiceList/getAllRehabRuleChoiceListFiles'));

export const getAllRehabRuleChoiceListFilesResolved =
	createAction<RehabQueryChoiceList>(
		addNamespace('choiceList/getAllRehabRuleChoiceListFilesResolved'),
	);

export const getAllRehabRuleChoiceListFilesRejected = createAction(
	addNamespace('choiceList/getAllRehabRuleChoiceListFilesRejected'),
);
